import React from "react";
import Select from "~/select";
import { IProps } from "./select-field.types";
import { useField } from "formik";
import "./select-field.scss";

/**
 * Wrapper to connect a select to a Formik field. Hidden inputs are also added so it behaves like a proper form control.
 * This technique was inspired by React Select.
 * @param props.name  Field name.
 * @param selectProps Other props to pass down to the select component.
 */
const SelectField = <IItem extends {}, IValue extends {} = string>({
    fieldProps,
    name,
    onSelect,
    ...selectProps
}: IProps<IItem, IValue>) => {
    const [{ value }, , { setValue }] = useField<IValue | IValue[]>({ ...(fieldProps as any), name });
    const values = Array.isArray(value) ? value : [value];
    return (
        <>
            <Select<IItem, IValue>
                labelledBy={name}
                onSelect={(values, items) => {
                    setValue(values);
                    if (typeof onSelect === "function") {
                        onSelect(items);
                    }
                }}
                selectedValues={value}
                {...(selectProps as any)}
            />

            {values.map((value) => (
                <input
                    key={String(value)}
                    name={name}
                    type="hidden"
                    value={typeof value === "undefined" || value === null ? "" : String(value)}
                />
            ))}
        </>
    );
};

export default SelectField;
